import { render, staticRenderFns } from "./backGround.vue?vue&type=template&id=c0ae2cca&scoped=true&"
import script from "./backGround.vue?vue&type=script&lang=js&"
export * from "./backGround.vue?vue&type=script&lang=js&"
import style0 from "./backGround.vue?vue&type=style&index=0&id=c0ae2cca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ae2cca",
  null
  
)

export default component.exports